/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2022-01-04 19:03:06
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const api = {
  // 列表
  getList: ({ query, body }, headers) => request({
    url: `${requestUrl}/auto-code/page?page=${query.page}&size=${query.size}&orders[0].asc=false&orders[0].column=createTime`,
    method: "post",
    data: body,
    headers
  }),
  addForm: data => request({
    url: `${requestUrl}/auto-code/cascade-create`,
    method: "post",
    data
  }),
  //
  editForm: data => request({
    url: `${requestUrl}/auto-code/cascade-update`,
    method: "PUT",
    data
  }),
  getDetailById: params => request({
    url: `${requestUrl}/auto-code/details`,
    method: "get",
    params
  }),
  deleteByIds: data => request({
    url: `${requestUrl}/auto-code/delete-batch`,
    method: "post",
    data: {
      keys: data
    }
  }),
  generateCodes: data => request({
    url: `${requestUrl}/auto-code-value/generate/batch/autocode`,
    method: "post",
    data
  })
};

export default api;
